import { borderRadius, breakpoints, color, fontWeight, spacing } from '@/theme/tokens';
import { typography } from '@/theme/typography';
import styled from '@emotion/styled';

const TermsPreview = styled.div`
    font-family: var(--font-noto-sans), Helvetica, Arial, sans-serif;

    * {
        font-family: inherit;
    }

    p,
    span {
        font-size: ${typography.paragraph4regular.fontSize} !important;
        line-height: ${typography.paragraph4regular.lineHeight} !important;
        letter-spacing: ${typography.paragraph4regular.letterSpacing} !important;
        font-weight: ${typography.paragraph4regular.fontWeight} !important;
    }

    p {
        margin: ${spacing[8]} 0 !important;
    }

    a {
        color: ${color.brand[50]};
    }

    tr td p {
        font-size: 12px !important;
    }

    section {
        margin-bottom: ${spacing[24]} !important;
        @media (max-width: ${breakpoints.md}) {
            margin-bottom: ${spacing[20]} !important;
        }
        @media (max-width: ${breakpoints.sm}) {
            margin-bottom: ${spacing[16]} !important;
        }
    }

    ul {
        margin: ${spacing[8]} 0 !important;
        padding-left: ${spacing[24]};
    }

    ul >li {
        &:not(:last-child) {
            padding-bottom: ${spacing[4]};
        }
        p {
            margin-top: ${spacing[0]} !important;
        }
    }

    ul li::marker {
        color: ${color.gray[80]};
        font-size: ${typography.paragraph4regular.fontSize} !important;
    }

    h1 {
        font-size: ${typography.heading1bold.fontSize} !important;
        line-height: ${typography.heading1bold.lineHeight} !important;
        letter-spacing: ${typography.heading1bold.letterSpacing}px !important;
        margin-bottom: ${spacing[8]} !important;
    }

    h3 {
        font-size: ${typography.heading1bold.fontSize} !important;
        line-height: ${typography.heading1bold.lineHeight} !important;
        letter-spacing: ${typography.heading1bold.letterSpacing}px !important;
        margin-bottom: ${spacing[8]} !important;
        margin-top: ${spacing[8]} !important;
    }

    u > p {
        margin: 0 !important;
    }

    section:last-child {
        p:last-child {
            margin-bottom: 0 !important;
        }
        margin-bottom: ${spacing[0]} !important;
    }

    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        border: 1px solid ${color.gray[20]} !important;
        border-radius: ${borderRadius[8]} !important;
        overflow: hidden;
        margin: ${spacing[16]} 0;

        thead {
            background-color: ${color.gray[5]} !important;
            font-weight: ${typography.label4semibold.fontWeight} !important;
            line-height: ${typography.label4semibold.lineHeight} !important;
            font-size: ${typography.label4semibold.fontSize} !important;
            letter-spacing: ${typography.label4semibold.letterSpacing}px !important;
        }

        tr {
            height: 46px;
        }

        th,
        td {
            padding: ${spacing[12]};
            text-align: left;
            border-bottom: 1px solid ${color.gray[20]};
            box-sizing: border-box;
            &:first-child {
                width: 400px;
            }

            &:last-child {
                width: 594px;
            }
        }

        @media (max-width: ${breakpoints.md}) {
            th, td {
                width: 215px !important;
            }
        }

        @media (max-width: ${breakpoints.sm}) {
            th, td {
                width: 139px !important;
                
            }
        }

        th {
            font-weight: 600;
            color: ${color.gray[80]};
        }

        td {
            color: ${color.gray[80]};
            font-size: ${typography.label4medium.fontSize} !important;
            line-height: ${typography.label4medium.lineHeight} !important;
            letter-spacing: ${typography.label4medium.letterSpacing}px !important;
            font-weight: ${typography.label4medium.fontWeight} !important;
        }

        tbody tr:last-child td {
            border-bottom: none;
        }
    }
    }

    ol {
        margin: ${spacing[8]} 0;
        list-style: none;
        counter-reset: item;
        padding-left: 0;
    }

    ol li {
        counter-increment: item;
        padding-left: ${spacing[20]};
        position: relative;


        counter-increment: item;
        &:not(:last-child) {
            padding-bottom: ${spacing[4]};
        }
        p {
            margin-top: ${spacing[0]} !important;
        }
        strong {
            font-weight: ${typography.paragraph4semibold.fontWeight} !important;
            font-size: ${typography.paragraph4semibold.fontSize} !important;
            line-height: ${typography.paragraph4semibold.lineHeight} !important;
            letter-spacing: ${typography.paragraph4semibold.letterSpacing}px !important;
        }
    }

    ol li::before {
        content: counter(item) ".";
        position: absolute;
        left: ${spacing[0]};
        width: ${spacing[20]};
        font-weight: ${typography.paragraph4semibold.fontWeight};
        font-size: ${typography.paragraph4semibold.fontSize};
        line-height: ${typography.paragraph4semibold.lineHeight};
        letter-spacing: ${typography.paragraph4semibold.letterSpacing};
        text-align: left;
    }

    .privacy-policy-section {
        p {
            margin-top: ${spacing[0]} !important;
        }
        u > p {
            margin-bottom: ${spacing[2]} !important;
        }
    }
`;

export default TermsPreview;
